/**
 * Styles of the report designs page. Its tiles, pills and buttons are the POI type pages'
 * (`CustomPoiTypes.styles.ts`) and its dialogs are framed like the teams' (`Teams.styles.ts`);
 * only what neither has is here.
 */

/** Above the list: what the page holds on the left, the way to add to it on the right. */
export const barStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 2,
  width: '100%',
  marginBottom: '12px',
};

/** The owner over its designs: the organization, or a team. */
export const ownerHeaderStyles = {
  px: 2.25,
  py: 1.25,
  gap: 1.25,
  alignItems: 'center',
  color: 'text.secondary',
  '& i': { fontSize: 18 },
};

/** One design's row, on the rhythm of a POI type's, and like it a way in: the row opens the design. */
export const designRowStyles = {
  px: 2.25,
  py: 2,
  alignItems: 'center',
  cursor: 'pointer',
  transition: 'background-color 120ms ease',
  '&:hover': { backgroundColor: 'action.hover' },
  '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.light', outlineOffset: -2 },
};

/** Over the editor: the way back to the list on the left, whose design this is on the right. */
export const detailBarStyles = {
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
  mb: 2,
};

/** The owner of the design that is open: its icon, then its name. */
export const detailOwnerStyles = {
  gap: 1,
  alignItems: 'center',
  minWidth: 0,
  color: 'text.secondary',
  '& i': { fontSize: 18 },
};

export const dialogBodyStyles = {
  px: 2.5,
  py: 2.5,
};

/** An owner in the picker: its icon, then its name, as the app settings picker draws a scope. */
export const ownerOptionStyles = {
  gap: 1,
  '& i': { fontSize: 18 },
};

/** Something to start a design from: its name over a line that tells it apart. */
export const startOptionStyles = {
  flexDirection: 'column',
  alignItems: 'flex-start',
  whiteSpace: 'normal',
};

/** A picture of a report beside its settings: an uploaded image on the paper it will be printed on. */
export const imageBoxStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 96,
  p: 1,
  borderRadius: 1,
  border: '1px solid',
  borderColor: 'divider',
  backgroundColor: '#fff',
  '& img': { display: 'block', maxWidth: '100%', maxHeight: 160, objectFit: 'contain' },
};

/** The same box with no picture in it: nothing chosen yet, or an image that is gone. */
export const imageEmptyStyles = {
  ...imageBoxStyles,
  px: 2,
  textAlign: 'center',
  color: 'text.secondary',
  fontSize: 13,
  backgroundColor: 'transparent',
  borderStyle: 'dashed',
};

export const imageMissingStyles = {
  ...imageEmptyStyles,
  color: 'warning.light',
  borderColor: 'warning.main',
};
